import React from 'react';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';

const AlternativeFlightSkeletonItem = () => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 392, h: 81 }
    : { w: 700, h: 63 };

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: height,
      }}
    >
      <PlaceholderLoader
        width={width}
        height={height}
        uid="alternative-flight-skeleton-item-skeleton"
        style={{ height: '100%', width: '100%', display: 'block' }}
      >
        {mobile ? (
          <>
            <rect x="10" y="10" width="74" height="14" rx="6" />
            <rect x="120" y="10" width="84" height="14" rx="6" />
            <rect x="10" y="59" width="167" height="13" rx="6" />
            <rect width="392" height="1" />
            <rect y="80" width="392" height="1" />
            <rect x="233" y="10" width="148" height="38" />
            <rect x="10" y="29" width="62" height="25" />
            <rect x="120" y="29" width="62" height="25" />
          </>
        ) : (
          <>
            <rect x="278" y="9" width="101" height="13" rx="6" />
            <rect x="424" y="9" width="101" height="13" rx="6" />
            <rect x="116" y="39" width="146" height="13" rx="6" />
            <rect width="700" height="1" />
            <rect y="62" width="700" height="1" />
            <rect x="554" y="15" width="135" height="34" />
            <rect x="278" y="30" width="101" height="23" />
            <rect x="424" y="30" width="101" height="23" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
};

const AlternativeFlightHeaderSkeleton: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { mobile } = useDeviceType();

  return (
    <div
      data-id="alternative-flight-header-skeleton"
      className={className}
      style={{
        padding: '5px 10px 0px',
      }}
    >
      <PlaceholderLoader
        uid={'SRLStatusSkeleton'}
        width={mobile ? 392 : 700}
        height={mobile ? 46 : 48}
        style={{
          width: '100%',
          height: mobile ? '46px' : '48px',
        }}
      >
        {mobile ? (
          <>
            <rect x="10" y="11" width="57" height="19" rx="6" />
            <rect x="10" y="33" width="84" height="13" rx="6" />
            <rect x="110" y="33" width="94" height="13" rx="6" />
            <rect x="232" y="33" width="94" height="13" rx="6" />
            <rect x="110" y="11" width="82" height="19" rx="6" />
            <rect x="232" y="11" width="113" height="19" rx="6" />
            <rect width="392" height="1" />
          </>
        ) : (
          <>
            <rect x="275" y="23" width="94" height="13" rx="6" />
            <rect x="397" y="23" width="122" height="13" rx="6" />
            <rect x="275" y="1" width="82" height="19" rx="6" />
            <rect x="1" y="24" width="115" height="13" rx="6" />
            <rect x="1" width="82" height="19" rx="6" />
            <rect x="397" y="1" width="88" height="19" rx="6" />
            <rect y="47" width="700" height="1" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
};

const AlternativeFlightResultsSkeleton: React.FC = () => {
  const counts = 10;
  return (
    <div>
      <AlternativeFlightHeaderSkeleton />
      {Array.from({ length: counts }, (_, i) => (
        <AlternativeFlightSkeletonItem key={i} />
      ))}
    </div>
  );
};

export default AlternativeFlightResultsSkeleton;
